import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['listItem', 'showMoreBtn', 'showLessBtn']
  static values = { initialDisplayCount: { type: Number, default: 1 } }

  declare readonly listItemTargets: HTMLElement[]
  declare readonly showMoreBtnTarget: HTMLElement
  declare readonly showLessBtnTarget: HTMLElement
  declare initialDisplayCountValue: number

  showMore (event: Event): void {
    event.preventDefault()
    this.listItemTargets.forEach(item => item.classList.remove('hidden'))
    this.showMoreBtnTarget.classList.add('hidden')
    this.showLessBtnTarget.classList.remove('hidden')
  }

  showLess (event: Event): void {
    event.preventDefault()
    this.listItemTargets.forEach((item, index) => {
      if (index >= this.initialDisplayCountValue) item.classList.add('hidden')
    })

    this.showMoreBtnTarget.classList.remove('hidden')
    this.showLessBtnTarget.classList.add('hidden')
  }
}
